import React, { useState, useEffect } from "react";
import { endPoints, DefaultImageBaseurl } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
  updateData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEye } from "react-icons/ai";
import { FaCheck, FaTimes } from "react-icons/fa";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const KYCList = () => {
  const [pending, setPending] = useState(true);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedKYC, setSelectedKYC] = useState(null);

  // Search and Filter states
  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");

  // "Set Reward to KYC Users" popup state
  const [showRewardModal, setShowRewardModal] = useState(false);
  const [rewardType, setRewardType] = useState("SC");
  const [rewardValue, setRewardValue] = useState("");
  const [savingReward, setSavingReward] = useState(false);

  // "Add User KYC" popup state
  const [showAddKycModal, setShowAddKycModal] = useState(false);
  const [searchType, setSearchType] = useState("email"); // "email" | "userid"
  const [userQuery, setUserQuery] = useState("");
  const [searchingUser, setSearchingUser] = useState(false);
  const [foundUser, setFoundUser] = useState(null);
  const [kycSelfie, setKycSelfie] = useState({ file: null, url: null });
  const [kycFront, setKycFront] = useState({ file: null, url: null });
  const [kycBack, setKycBack] = useState({ file: null, url: null });
  const [addDocType, setAddDocType] = useState("");
  const [submittingKyc, setSubmittingKyc] = useState(false);
  const [existingKyc, setExistingKyc] = useState([]);

  let image_baseurl = `${endPoints.apiBaseUrl}`;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchKYCData("", "All");
  }, []);

  const fetchKYCData = async (search = "", status = "All") => {
    // Build query parameters
    const params = new URLSearchParams();
    params.append("search", search);
    params.append("status", status);
    
    let url = `${endPoints.api.GET_KYC_LIST}?${params.toString()}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        console.log("data", response);
        setIsLoading(false);
        if (response.status === "success" || response.status === 200) {
          setRows(response.data || []);
          setPending(false);
        } else {
          ErrorToast(response?.message || "Failed to fetch KYC data");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast("An error occurred while fetching KYC data");
      });
  };

  const openRewardModal = async () => {
    setShowRewardModal(true);
    try {
      const res = await getAllData(endPoints.api.GET_KYC_REWARD);
      if ((res?.status === "success" || res?.status === 200) && res?.data) {
        setRewardType(res.data.rewardType || "SC");
        setRewardValue(
          res.data.rewardValue != null ? String(res.data.rewardValue) : "",
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRewardSubmit = async () => {
    const value = parseFloat(rewardValue);
    if (!rewardType || isNaN(value) || value < 0) {
      ErrorToast("Enter a valid reward value");
      return;
    }
    setSavingReward(true);
    try {
      const res = await addData(endPoints.api.SAVE_KYC_REWARD, {
        rewardType,
        rewardValue: value,
      });
      setSavingReward(false);
      if (res?.data?.status === "success" || res?.status === 200) {
        SuccesToast(res?.data?.message || "KYC reward saved successfully");
        setShowRewardModal(false);
      } else {
        ErrorToast(res?.data?.message || "Failed to save reward");
      }
    } catch (error) {
      setSavingReward(false);
      console.error(error);
      ErrorToast("An error occurred while saving reward");
    }
  };

  const openAddKycModal = () => {
    setSearchType("email");
    setUserQuery("");
    setFoundUser(null);
    setKycSelfie({ file: null, url: null });
    setKycFront({ file: null, url: null });
    setKycBack({ file: null, url: null });
    setAddDocType("");
    setExistingKyc([]);
    setShowAddKycModal(true);
  };

  const searchUser = async () => {
    if (!userQuery.trim()) {
      ErrorToast("Enter an email or user ID");
      return;
    }
    setSearchingUser(true);
    setFoundUser(null);
    try {
      const url =
        searchType === "email"
          ? `${endPoints.api.GET_USER_BY_EMAIL}${encodeURIComponent(userQuery.trim())}`
          : `${endPoints.api.GET_BY_USERID}/${userQuery.trim()}`;
      const res = await getAllData(url);
      const user = res?.data && (res.data.idUser || res.data.id_user) ? res.data : res?.idUser ? res : null;
      if (user) {
        setFoundUser(user);
        // Flag if this user already has KYC on record so we don't duplicate.
        const uid = user.idUser || user.id_user;
        try {
          const kycRes = await getAllData(`${endPoints.api.GET_KYC_USER}${uid}`);
          const list = Array.isArray(kycRes)
            ? kycRes
            : Array.isArray(kycRes?.data)
            ? kycRes.data
            : [];
          setExistingKyc(list);
        } catch (e) {
          setExistingKyc([]);
        }
      } else {
        ErrorToast("No user found");
      }
    } catch (error) {
      console.error(error);
      ErrorToast("No user found");
    } finally {
      setSearchingUser(false);
    }
  };

  const uploadKycImage = async (event, setter) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!file.name.match(/\.(jpg|jpeg|png|gif)$/i)) {
      ErrorToast("Please select a valid image file");
      return;
    }
    const formdata = new FormData();
    formdata.append("file", file);
    setSubmittingKyc(true);
    try {
      const resp = await fetch(`${endPoints.apiBaseUrl}${endPoints.api.KYC_UPLOAD}`, {
        method: "POST",
        body: formdata,
      });
      const result = await resp.json();
      if (result.status === "success") {
        setter({ file, url: result.data });
      } else {
        ErrorToast(result.message || "Image upload failed");
      }
    } catch (error) {
      console.error(error);
      ErrorToast("Image upload failed");
    } finally {
      setSubmittingKyc(false);
    }
  };

  const submitAddKyc = async () => {
    const idUser = foundUser?.idUser || foundUser?.id_user;
    if (!idUser) {
      ErrorToast("Search and select a user first");
      return;
    }
    if (!kycSelfie.url || !kycFront.url || !kycBack.url) {
      ErrorToast("Please upload selfie, front and back of document");
      return;
    }
    if (!addDocType) {
      ErrorToast("Please select document type");
      return;
    }
    setSubmittingKyc(true);
    try {
      const payload = {
        idUser,
        selfie: kycSelfie.url,
        front: kycFront.url,
        back: kycBack.url,
        doc_type: addDocType,
        status: "Pending",
      };
      const res = await addData(endPoints.api.SAVE_KYC, payload);
      if (res?.data?.status === "success" || res?.status === 200) {
        SuccesToast("KYC added successfully");
        setShowAddKycModal(false);
        fetchKYCData(searchValue, statusFilter);
      } else {
        ErrorToast(res?.data?.message || "Failed to add KYC");
      }
    } catch (error) {
      console.error(error);
      ErrorToast("Failed to add KYC");
    } finally {
      setSubmittingKyc(false);
    }
  };

  const handlePreviewClose = () => {
    setShowPreviewModal(false);
    setSelectedKYC(null);
  };

  const handlePreviewShow = (kycData) => {
    setSelectedKYC(kycData);
    setShowPreviewModal(true);
  };

  const handleKYCAction = async (userId, action) => {
    // action: "pass" or "fail"
    setIsLoading(true);
    const payload = {
      userId: userId,
      status: action,
    };

    try {
      const response = await updateData(
        endPoints.api.UPDATE_KYC_STATUS,
        payload,
      );
      setIsLoading(false);

      if (response.status === 200 || response.data?.status === "success") {
        SuccesToast(
          action === "pass"
            ? "KYC approved successfully"
            : "KYC rejected successfully",
        );
        fetchKYCData(); // Refresh the list
      } else {
        ErrorToast(response?.data?.message || "Failed to update KYC status");
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      ErrorToast("An error occurred while updating KYC status");
    }
  };

  const approveKyc = async (id) => {
    try {
      let url = `${endPoints.api.UPDATE_KYC_STATUS}/?id=${id}&status=Approved`;
      // let data = {
      //   id: id,
      //   status: "Approved",
      // };
      setIsLoading(true);
      let response = await updateData(url);
      setIsLoading(false);
      if (response?.data?.status == "success") {
        SuccesToast(response?.data?.message);
        fetchKYCData(searchValue, statusFilter); // Refresh the list
      } else {
        ErrorToast(response?.data?.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const rejectKyc = async (id) => {
    try {
      let url = `${endPoints.api.UPDATE_KYC_STATUS}?id=${id?.id}&status=Rejected`;
      // let data = {
      //   id: id?.id,
      //   status: "Rejected",
      // };
      setIsLoading(true);
      let response = await updateData(url);
      setIsLoading(false);
      console.log("reject response", response);
      if (response?.data?.status == "success") {
        SuccesToast(response.data.message);
        fetchKYCData(searchValue, statusFilter); // Refresh the list
      } else {
        ErrorToast(response.data.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "/images/placeholder.png";
    if (imagePath.startsWith("http")) return imagePath;
    return `${image_baseurl}${imagePath}`;
  };

  // Search and filter handler
  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleSearchClick = () => {
    setPage(0); // Reset to first page when searching
    fetchKYCData(searchValue, statusFilter);
  };

  const handleStatusFilterChange = (event) => {
    const value = event.target.value;
    setStatusFilter(value);
  };

  // Handle Enter key press in search input
  const handleSearchKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearchClick();
    }
  };

  // {
  //           "id": 1,
  //           "idUser": 3189,
  //           "selfie": "documnet/1773841409454_bannerpng",
  //           "front": "documnet/1773841418904_bannerpng",
  //           "back": "documnet/1773841426053_bannerpng",
  //           "status": "Pending",
  //           "doc_type": null,
  //           "createdOn": "2026-03-18T14:05:07.000+00:00"
  //       },

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    KYC List
                  </h3>
                  <div>
                    <Button
                      variant="success"
                      onClick={openAddKycModal}
                      style={{ height: "38px", marginRight: "10px" }}
                    >
                      Add User KYC
                    </Button>
                    <Button
                      variant="warning"
                      onClick={openRewardModal}
                      style={{ height: "38px" }}
                    >
                      Set Reward to KYC Users
                    </Button>
                  </div>
                </div>
              </div>

              {/* Search and Filter Section */}
              <div className="row mt-3" style={{ marginBottom: "20px" }}>
                <div className="col-md-5">
                  <TextField
                    fullWidth
                    placeholder="Search by User ID, Name, Address, or City..."
                    type="text"
                    onChange={handleSearchChange}
                    onKeyPress={handleSearchKeyPress}
                    value={searchValue}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    size="small"
                  />
                </div>
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel id="status-filter-label">KYC Status</InputLabel>
                    <Select
                      labelId="status-filter-label"
                      id="status-filter"
                      value={statusFilter}
                      label="KYC Status"
                      onChange={handleStatusFilterChange}
                    >
                      <MenuItem value="All">All</MenuItem>
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="Approved">Approved</MenuItem>
                      <MenuItem value="Rejected">Rejected</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-2">
                  <Button
                    variant="primary"
                    onClick={handleSearchClick}
                    style={{ height: "40px", width: "100%" }}
                  >
                    Search
                  </Button>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-12">
                  <TableContainer component={Paper}>
                    <Table
                      sx={{ minWidth: 500 }}
                      aria-label="custom pagination table"
                    >
                      <TableHead>
                        <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            User ID
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Name
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Mobile
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Address
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Birth Date
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Status
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Preview
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? rows.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : rows
                        ).map((row, index) => (
                          <TableRow key={row.id || index}>
                            <TableCell>{row.idUser}</TableCell>
                            <TableCell>
                              {row?.name}{" "}
                            </TableCell>
                            <TableCell>
                              {row?.mobile}{" "}
                            </TableCell>
                            <TableCell>
                              {row?.address}{" "}
                            </TableCell>
                            <TableCell>
                              {row?.birthDate}{" "}
                            </TableCell>
                            <TableCell>{row?.status}</TableCell>
                            <TableCell>
                              <Button
                                variant="info"
                                size="sm"
                                onClick={() => handlePreviewShow(row)}
                              >
                                <AiOutlineEye size={18} /> Preview
                              </Button>
                            </TableCell>
                            {row?.status === "Pending" ? (
                              <TableCell>
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => approveKyc(row?.id)}
                                  style={{ marginRight: "5px" }}
                                  // disabled={row.status === "approved" || row.status === "pass"}
                                >
                                  <FaCheck /> Pass
                                </Button>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => rejectKyc(row)}
                                  // disabled={row.status === "rejected" || row.status === "fail"}
                                >
                                  <FaTimes /> Reject
                                </Button>
                              </TableCell>
                            ) : (
                              <TableCell>
                                <span
                                  style={{
                                    color:
                                      row.status === "Approved"
                                        ? "green"
                                        : "red",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {row.status}
                                </span>
                              </TableCell>
                            )}
                          </TableRow>
                        ))}

                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={8} />
                          </TableRow>
                        )}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={[
                              5,
                              10,
                              25,
                              { label: "All", value: -1 },
                            ]}
                            colSpan={8}
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: {
                                "aria-label": "rows per page",
                              },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add User KYC Modal */}
      <Modal
        show={showAddKycModal}
        onHide={() => setShowAddKycModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add User KYC</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: "13px", color: "#666", marginBottom: "16px" }}>
            Search a user by email or user ID, then upload the KYC documents you
            received (e.g. over email). The record is saved as <b>Pending</b> and
            shows up in the list for review.
          </p>

          {/* Search row */}
          <div className="row" style={{ marginBottom: "16px" }}>
            <div className="col-md-3">
              <Form.Control
                as="select"
                value={searchType}
                onChange={(e) => {
                  setSearchType(e.target.value);
                  setFoundUser(null);
                }}
              >
                <option value="email">Email</option>
                <option value="userid">User ID</option>
              </Form.Control>
            </div>
            <div className="col-md-6">
              <Form.Control
                type={searchType === "userid" ? "number" : "text"}
                placeholder={
                  searchType === "email" ? "Enter user email" : "Enter user ID"
                }
                value={userQuery}
                onChange={(e) => setUserQuery(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") searchUser();
                }}
              />
            </div>
            <div className="col-md-3">
              <Button
                variant="primary"
                onClick={searchUser}
                disabled={searchingUser}
                style={{ width: "100%" }}
              >
                {searchingUser ? "Searching..." : "Search"}
              </Button>
            </div>
          </div>

          {/* Found user */}
          {foundUser && (
            <div
              style={{
                border: "1px solid #28a745",
                borderRadius: "6px",
                padding: "10px",
                marginBottom: "16px",
                background: "#f6fff8",
              }}
            >
              <b>Selected user:</b> {foundUser.name || foundUser.surname || "—"}
              {" | "}
              {foundUser.email}
              {" | "}
              ID: {foundUser.idUser || foundUser.id_user}
            </div>
          )}

          {/* Already-submitted warning */}
          {foundUser && existingKyc.length > 0 && (
            <div
              style={{
                border: "1px solid #ffc107",
                borderRadius: "6px",
                padding: "10px",
                marginBottom: "16px",
                background: "#fff9e6",
              }}
            >
              ⚠️ This user already has {existingKyc.length} KYC submission
              {existingKyc.length > 1 ? "s" : ""} on record (latest status:{" "}
              <b>{existingKyc[0]?.status || "—"}</b>). Submitting will add another
              record.
            </div>
          )}

          {/* Upload section (after user selected) */}
          {foundUser && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Selfie {kycSelfie.url ? "✓" : ""}</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => uploadKycImage(e, setKycSelfie)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Document Front {kycFront.url ? "✓" : ""}</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => uploadKycImage(e, setKycFront)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Document Back {kycBack.url ? "✓" : ""}</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => uploadKycImage(e, setKycBack)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Document Type</Form.Label>
                <Form.Control
                  as="select"
                  value={addDocType}
                  onChange={(e) => setAddDocType(e.target.value)}
                >
                  <option value="">Select Document Type</option>
                  <option value="PASSPORT">Passport</option>
                  <option value="DRIVER_LICENSE">Driver License</option>
                </Form.Control>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddKycModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={submitAddKyc}
            disabled={submittingKyc || !foundUser}
          >
            {submittingKyc ? "Saving..." : "Submit KYC"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Set Reward to KYC Users Modal */}
      <Modal
        show={showRewardModal}
        onHide={() => setShowRewardModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Set Reward to KYC Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: "13px", color: "#666", marginBottom: "16px" }}>
            This reward is granted <b>only to users whose KYC status is set to
            verify_kyc</b> — we ask them to verify their KYC before accessing
            anything, and it is credited once an admin approves their KYC.
          </p>
          <Form.Group className="mb-3">
            <Form.Label>Reward Type</Form.Label>
            <Form.Control
              as="select"
              value={rewardType}
              onChange={(e) => setRewardType(e.target.value)}
            >
              <option value="SC">SC</option>
              <option value="GC">GC</option>
            </Form.Control>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Value</Form.Label>
            <Form.Control
              type="number"
              min="0"
              placeholder="Enter amount"
              value={rewardValue}
              onChange={(e) => setRewardValue(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowRewardModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleRewardSubmit}
            disabled={savingReward}
          >
            {savingReward ? "Saving..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Preview Modal */}
      <Modal
        show={showPreviewModal}
        onHide={handlePreviewClose}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>KYC Documents Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedKYC && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 text-center mb-4">
                  <h6 className="mb-2">Selfie</h6>
                  {selectedKYC.selfie ? (
                    <img
                      src={`${endPoints?.apiBaseUrl}${selectedKYC?.selfie}`}
                      alt="Selfie"
                      style={{
                        width: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "5px",
                      }}
                    />
                  ) : (
                    <p style={{ color: "#999" }}>No selfie available</p>
                  )}
                </div>
                <div className="col-md-12 text-center mb-4">
                  <h6 className="mb-2">Document Front</h6>
                  {selectedKYC.front ? (
                    <img
                      src={`${endPoints?.apiBaseUrl}${selectedKYC?.front}`}
                      alt="Document Front"
                      style={{
                        width: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "5px",
                      }}
                    />
                  ) : (
                    <p style={{ color: "#999" }}>No document front available</p>
                  )}
                </div>
                <div className="col-md-12 text-center mb-4">
                  <h6 className="mb-2">Document Back</h6>
                  {selectedKYC.back ? (
                    <img
                      src={`${endPoints?.apiBaseUrl}${selectedKYC?.back}`}
                      alt="Document Back"
                      style={{
                        width: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "5px",
                      }}
                    />
                  ) : (
                    <p style={{ color: "#999" }}>No document back available</p>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePreviewClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default KYCList;
